import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ProjectType } from '@/domain/pdf-reports/pdf-reports.type';
import { deleteProjectVenue } from '@/domain/project-venue/actions/delete-project-venue.action';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ModalReportExporter } from '@/ui/pages/app/components/project-page/ModalReportExporter';
import { PageProjectHeader } from '@/ui/pages/app/components/project-page/PageProjectHeader';
import { ProjectScores } from '@/ui/pages/app/components/project-page/ProjectScores';

import { HeaderButtons } from './components/HeaderButtons';
import { ProjectVenueCards } from './components/ProjectVenueCards';

export function ProjectVenue() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [reportExporterModalOpen, setReportExporterModalOpen] = useState(false);

  const project = useAppSelector(selectCurrentProjectVenue);

  const onClickBack = () => {
    navigate('/app/projects/venue');
  };

  const onClickEdit = () => {
    navigate(`/app/projects/venue/${project?.id}/edit`);
  };

  const onClickDelete = async () => {
    try {
      await dispatch(deleteProjectVenue(project?.id || -1)).unwrap();
      navigate('/app/projects/venue');
    } catch (error) {
      console.error(error);
    }
  };

  const onClickExportReport = () => {
    setReportExporterModalOpen(true);
  };

  const onClickOpenDates = () => {
    navigate(`/app/projects/venue/${project?.id}/dates`);
  };

  const onClickOpenStructure = () => {
    navigate(`/app/projects/venue/${project?.id}/structure`);
  };

  if (!project) {
    return null;
  }

  return (
    <>
      <ModalReportExporter
        open={reportExporterModalOpen}
        onClose={() => setReportExporterModalOpen(false)}
        project={project}
        projectType={ProjectType.VENUE}
      />
      <Stack sx={{ gap: 3 }}>
        <PageProjectHeader
          project={project}
          backButtonText={translate('ProjectsVenue.my-seasons')}
          onClickBack={onClickBack}
          rightComponent={
            <HeaderButtons
              onClickEdit={onClickEdit}
              onClickDelete={onClickDelete}
              onClickExportReport={onClickExportReport}
            />
          }
        />
        <ProjectScores
          project={project}
          showDetailsMode={'none'}
          onClickScore={undefined}
        />
        <CalculateScoreTextInformation />
        <ProjectVenueCards
          onClickOpenDates={onClickOpenDates}
          onClickOpenStructure={onClickOpenStructure}
        />
      </Stack>
    </>
  );
}

function CalculateScoreTextInformation() {
  return (
    <Box sx={{ my: 2 }}>
      <Typography sx={{ textAlign: 'center' }}>
        {translate('ProjectsVenue.calculate-score-information')}
      </Typography>
    </Box>
  );
}
